import React, { useContext, useEffect, useState } from "react";
import { Button, Form, FormGroup } from "react-bootstrap";

import ApiService from "services/ApiService";
import { ContextOne } from "contexts/ContextOne";
import { isValidEmail } from "lib/Utils";
import { TextInput } from "components/UI/Forms"
import Spinner from "components/UI/Spinner";

import "./UserSelectForm.scss";

const UserSelectForm = (props) => {
  const { state: { loading }, dispatch } = useContext(ContextOne);

  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    let user = {
      email: email
    }

    props.handleSubmit(user);
  };

  const validateForm = () => {
    return isValidEmail(email);
  };

  useEffect(() => {
    if (props.uuid) {
      async function getUserWrapper(email) {
        dispatch({ type: "loading", val: true });

        const user = await ApiService.getUserByEmail(email);
        setEmail(user.email);

        dispatch({ type: "loading", val: false });
      }

      getUserWrapper(props.uuid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uuid]);

  return (
    <div className="user-form-component text-center">
      <Spinner show={loading} />

      <Form onSubmit={handleSubmit}>

        <div className="input-table">
          <TextInput
            id="email"
            label="Email"
            value={email}
            onChange={(event) => { setEmail(event.target.value) }}
          /> 
        </div>

        <div className="required-field-text">
          <span className="asterisk">*</span> Required Field
        </div>

        <FormGroup controlId="buttons">
          <Button
            disabled={!validateForm() || props.loading}
            type="submit"
          >
            Submit
          </Button>
          { props.cancelForm &&
            <Button
              className="btn-secondary"
              onClick={props.cancelForm}
            >
              Cancel
            </Button>
          }
        </FormGroup>
      </Form>
    </div>
  );
};

export default UserSelectForm;
